"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagST = function FlagST(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54,146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "64.55",
    width: "409.6",
    height: "141.24",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-190.87,144.33-51.76,12.18-190.87-120a7,7,0,0,0-2.13,5V139.3a7,7,0,0,0,2.13,5Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.64-20,36.87,1.7l22.88.17a3.08,3.08,0,0,1,1.81,5.56L43.16,21l6.9,21.81a3.08,3.08,0,0,1-4.73,3.44L26.71,33,8.1,46.27a3.08,3.08,0,0,1-4.73-3.44L10.27,21-8.12,7.43a3.08,3.08,0,0,1,1.8-5.56L16.55,1.7,23.79-20a3.08,3.08,0,0,1,5.85,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M135.24-20,142.48,1.7l22.87.17a3.08,3.08,0,0,1,1.81,5.56L148.76,21l6.9,21.81a3.08,3.08,0,0,1-4.73,3.44L132.32,33l-18.61,13.3A3.08,3.08,0,0,1,109,42.83L115.88,21,97.47,7.43a3.08,3.08,0,0,1,1.81-5.56l22.88-.17L129.39-20a3.08,3.08,0,0,1,5.85,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#464655"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagST;
exports["default"] = _default;